function Header() {
  return (
    <div className="container">
      <div className="header">
        <img
          src="/images/TRAVA.svg"
          width={80}
          height={20}
          alt="trava's logo"
        />
        <a href="https://trava.app.link/web-signup">
          <div className="coming-soon">
            <p className="coming-soon-item coming-soon-text-short">
              Available on
            </p>
            <p className="coming-soon-item coming-soon-text-long">
              Available on
            </p>
            <div className="coming-soon-icons">
              <img
                className="coming-soon-item"
                src="/images/APPLE.svg"
                alt="app store logo"
                width={17}
                height={21}
              />
              <img
                className="coming-soon-item"
                src="/images/ANDROID.svg"
                alt="play store logo"
                width={22}
                height={13}
              />
            </div>
          </div>
        </a>
      </div>
    </div>
  );
}

export { Header };
